<template>
  <div class="uk-background-muted uk-padding-small">
    <div class="uk-container">
      <div class="uk-child-width-1-2@m uk-grid uk-flex uk-flex-middle">
        <div class="uk-visible@m"><h3 class="mp-color-default">Endpoint</h3></div>
        <div>
          <select class="uk-select uk-border-rounded" v-model="selectedEndpointIndex" @change="$emit('endpoint-changed', selectedEndpointIndex)">
            <option :key="i" v-for="(endpoint, i) in schema.endpoints" :value="i">{{ endpoint.name }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EndpointSelector",
    props: ['index', 'schema'],

    data: function () {
      return {
        selectedEndpointIndex: this.index
      }
    }
  }
</script>

<style scoped>

</style>
